export const LEVELS = ["A1", "A2", "B1", "B2", "C1", "C2"];

// Fisher-Yates gives each item equal selection probability, without repeats.
export const sample = (items, random = Math.random) => {
  const shuffled = [...items];
  for (let i = shuffled.length - 1; i > 0; i -= 1) {
    const j = Math.floor(random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled.slice(0, 3);
};

export class EnglishLevelTest {
  constructor(bank, random = Math.random) {
    this.rounds = LEVELS.map((level) => sample(bank.filter((q) => q.level === level), random));
    this.levelIndex = 1;
    this.position = 0;
    this.correct = 0;
    this.answered = 0;
    this.passed = "A1";
    this.result = null;
  }

  get question() {
    return this.result ? null : this.rounds[this.levelIndex][this.position];
  }

  answer(index) {
    if (this.result || !Number.isInteger(index) || index < 0 || index > 3) return;
    if (index === this.question.correctIndex) this.correct += 1;
    this.answered += 1;
    this.position += 1;
    if (this.position < 3) return;
    if (this.correct < 2) {
      this.result = this.passed;
      return;
    }
    this.passed = LEVELS[this.levelIndex];
    if (this.levelIndex === LEVELS.length - 1) {
      this.result = this.passed;
      return;
    }
    this.levelIndex += 1;
    this.position = 0;
    this.correct = 0;
  }
}
